<p-breadcrumb [model]="items" styleClass="border-none bg-transparent py-2">
  <ng-template #item let-item>
    @if (item.routerLink) {
      <a [routerLink]="item.routerLink" class="flex">
        @if (item.icon) {
          <span class="material-symbols-outlined" style="font-size: 16px">{{
            item.icon
          }}</span>
        }
        <span
          class="text-sm"
          [ngClass]="{
            'font-medium': !item.isLast,
            'font-bold': item.isLast,
            'text-text-400': !item.isLast,
            'text-text-900': item.isLast,
          }"
          >{{ item.label }}</span
        >
      </a>
    } @else {
      <a [href]="item.url">
        <span class="text-sm font-medium text-color">{{ item.label }}</span>
      </a>
    }
  </ng-template>
  <ng-template #separator>
    <span class="font-bold text-text-400">/</span>
  </ng-template>
</p-breadcrumb>
